import React, { useEffect, useState } from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import Aos from 'aos'
import { getWebsitePolicy } from "../Common/apis";
import Loader from '../Loader/Loader'

function Terms() {
   const [data, setData] = useState({});
   const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);

   useEffect(() => {
    getWebsitePolicy()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      }).finally(() => setLoading(false));
  }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        {loading && <Loader />}
        <h6 className="font-[500] text-center pt-[130px] pb-[56px] md:text-[110px] text-[60px] md:leading-[119px] leading-[70px] text-[#000000]">Terms & <span className='italic text-[#6953A3] font-dmserif'>Condition</span></h6>
        <div style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)" }} className='rounded-[19px] border-[1px] border-[#B99FFF] max-w-[1234px] w-full mx-auto py-[55px] px-[36px]'>
          <div dangerouslySetInnerHTML={{ __html: data?.termsAndConditions }} />
          {/* <h2 className="font-[400] font-sans text-[20px] leading-[26px] text-[#000000] pb-[30px]">Welcome to GISUL. By accessing or using our website and services, you agree to comply with the following Terms and Conditions. Please read them carefully.</h2>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] pb-[30px]">1. Acceptance of Terms</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">By registering for courses, accessing content, or using any part of the GISUL platform, you acknowledge that you have read, understood, and agree to be bound by these terms. If you do not agree, please refrain from using our services.</p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">2. Services Provided</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">GISUL offers online and instructor-led training courses, certifications, and resources focused on AWS and other IT-related topics. The services include:
            <ul className='list-disc pl-[20px]'>
              <li>
                Access to course materials, labs, and learning resources.
              </li>
              <li>
                Certification preparation and guidance.
              </li>
              <li>
                Support and updates related to training programs.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">3. User Responsibilities</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">You agree to:
            <ul className='list-disc pl-[20px]'>
              <li> Provide accurate and complete information during registration.</li>
              <li> Maintain the confidentiality of your account credentials.</li>
              <li>Use GISUL services only for lawful purposes and in compliance with these terms.</li>
              <li> Respect intellectual property rights and avoid copying, sharing, or distributing course materials without permission.</li>
            </ul>
          </p>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">Prohibited Activities Include:
            <ul className='list-disc pl-[20px]'>
              <li> Unauthorized sharing, reselling, or redistribution of course materials.</li>
              <li>Misuse of the platform, including attempts to hack, disrupt, or damage systems.</li>
              <li>Using GISUL services for illegal activities or to harm others.</li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">4. Payments and Refunds</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            <ul className='list-disc pl-[20px]'>
              <li>
                <span className='font-[500]'>Pricing:  </span> Course fees are listed on the website and may change without prior notice.
              </li>
              <li>
                <span className='font-[500]'>Payment Methods: </span> Secure online payments are processed via trusted third-party providers.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">5. Intellectual Property Rights</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            <ul className='list-disc pl-[20px]'>
              <li>
                All content provided by GISUL, including text, videos, graphics, and course materials, is protected by copyright laws and remains the property of GISUL.
              </li>
              <li>
                You may not reproduce, distribute, or use any content for commercial purposes without prior written consent.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">6. Certification Disclaimer</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">Completion of courses does not guarantee certification. Certifications are issued only upon successful completion of exams conducted by AWS or other third-party providers.</p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">7. Limitation of Liability</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            <ul className='list-disc pl-[20px]'>
              <li>
                GISUL is not liable for any indirect, incidental, or consequential damages resulting from the use or inability to use our services.
              </li>
              <li>
                While we strive for accuracy, GISUL does not guarantee that course content will always be error-free or up-to-date.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">8. Privacy Policy</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">Your use of GISUL services is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information.
            <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">9. Termination of Services</h6>
            <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">We reserve the right to:
              <ul className='list-disc pl-[20px]'>
                <li>
                  Suspend or terminate access to services without prior notice if you violate these terms.
                </li>
                <li>
                  Modify or discontinue services at any time without liability.
                </li>
              </ul>
            </p>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">10. Changes to Terms</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">GISUL may update these Terms and Conditions from time to time. Changes will be posted on this page, and continued use of services constitutes acceptance of the revised terms.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">11. Governing Law</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">These terms are governed by and interpreted under the laws of [Insert Jurisdiction]. Disputes shall be resolved through arbitration or courts in the specified jurisdiction.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">12. Contact Information</h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">For questions or concerns about these Terms and Conditions, please contact us at:

            <ul className=''>
              <li>
                <span className='font-[500]'>Email: </span>
              </li>
              <li>
                <span className='font-[500]'>Phone: </span>
              </li>
              <li>
                <span className='font-[500]'>Address: </span>
              </li>
            </ul>
            By using GISUL, you acknowledge and agree to these Terms and Conditions
          </p> */}
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Terms